import Api from "~/service/Api";

class ProviderBetaFeaturesRepository {
  fetch() {
    return Api.get("/provider-beta-features");
  }
}

export default ProviderBetaFeaturesRepository;
